export default __webpack_public_path__ + "static/worker1-343d693caa87fe07c00f36010ce14d48.jpeg";